import type { ReactNode } from 'react'

export function EmptyState({
  judul = 'Belum ada data',
  deskripsi,
  aksi,
  ikon,
}: {
  judul?: string
  deskripsi?: ReactNode
  aksi?: ReactNode
  ikon?: ReactNode
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 px-6 py-12 text-center">
      <div className="flex h-12 w-12 items-center justify-center rounded-full bg-netral-100 text-2xl text-netral-400">
        {ikon ?? '∅'}
      </div>
      <p className="text-sm font-semibold text-netral-700">{judul}</p>
      {deskripsi ? <p className="max-w-md text-sm text-netral-500">{deskripsi}</p> : null}
      {aksi ? <div className="mt-1">{aksi}</div> : null}
    </div>
  )
}
